import React, { useRef, useEffect, useState } from 'react';

const Centered = ({ initialData = { simchas: [] }, title = 'שמחות בקהילה', showTitle = true, bgColor }) => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const simchas = (initialData.simchas || []).filter(
    s => !s.expiryDate || new Date(s.expiryDate) > now
  );

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.clientHeight;
        const itemEl = containerRef.current.querySelector('[data-simcha-item]');
        const itemHeight = itemEl?.offsetHeight || 0;
        const contentHeight = simchas.length * (itemHeight + 14);
        setNeedsScroll(contentHeight > containerHeight + containerHeight * 0.1);
      }
    };
    const timer = setTimeout(checkScroll, 100);
    const ro = new ResizeObserver(checkScroll);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => { clearTimeout(timer); ro.disconnect(); };
  }, [simchas]);

  const getLabel = (type, customType) => {
    const map = {
      birth_boy: 'הולדת הבן', birth_girl: 'הולדת הבת',
      grandchild_boy: 'הולדת נכד', grandchild_girl: 'הולדת נכדה',
      engagement_boy: 'אירוסי הבן', engagement_girl: 'אירוסי הבת',
      wedding_boy: 'חתונת הבן', wedding_girl: 'חתונת הבת',
      bar_mitzvah: 'בר מצווה', other: customType || 'שמחה',
    };
    return map[type] || customType || 'שמחה';
  };

  const boldLabel = (type, label, boldWords) => {
    if (type !== 'other') return <strong>{label}</strong>;
    if (!boldWords?.length) return label;
    return label.split(/(\s+)/).map((w, i) =>
      boldWords.includes(w.trim()) && w.trim() ? <strong key={i}>{w}</strong> : w
    );
  };

  const renderCard = (simcha, keyPrefix = '', isOriginal = true) => {
    const label = getLabel(simcha.type, simcha.customType);
    return (
      <div
        key={`${keyPrefix}${simcha.id}`}
        {...(isOriginal && { 'data-simcha-item': true })}
        style={{ textAlign: 'center', paddingBottom: '14px' }}
      >
        <div style={{ color: '#8a6d08', fontSize: '0.67em', letterSpacing: '0.15em', marginBottom: '4px' }}>
          {boldLabel(simcha.type, label, simcha.customTypeBold)}{simcha.celebrant ? ` · ${simcha.celebrant}` : ''}
        </div>
        <div style={{ color: '#1e3a5f', fontWeight: 700, fontSize: '0.9em' }}>
          {simcha.name}
        </div>
        {simcha.additionalText && (
          <div style={{ color: '#64748b', fontSize: '0.67em', fontStyle: 'italic', marginTop: '3px' }}>
            {simcha.additionalText}
          </div>
        )}
        {/* ornamental divider */}
        <div style={{
          margin: '10px auto 0',
          width: '40%',
          height: '1px',
          background: 'linear-gradient(to left, transparent, #c8a84b 30%, #c8a84b 70%, transparent)',
        }} />
      </div>
    );
  };

  return (
    <div style={{
      padding: '12px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      backgroundColor: bgColor || '#ffffff',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{ textAlign: 'center', marginBottom: '12px' }}>
          <h3 style={{ margin: '0 0 4px 0', color: '#1e3a5f', fontWeight: 700, fontSize: '0.875em', letterSpacing: '0.06em' }}>
            {title}
          </h3>
          <div style={{ height: '2px', background: 'linear-gradient(to left, transparent, #8a6d08 20%, #8a6d08 80%, transparent)' }} />
        </div>
      )}

      <div ref={containerRef} style={{ overflow: 'hidden', flex: 1, position: 'relative' }}>
        {simchas.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.8em', padding: '10px' }}>
            אין שמחות כרגע
          </div>
        ) : (
          <>
            {needsScroll && (
              <style>
                {`@keyframes scrollSimchasCentered {
                  0%   { transform: translateY(0); }
                  100% { transform: translateY(calc(-100% / 3)); }
                }`}
              </style>
            )}
            <div ref={contentRef} style={{ animation: needsScroll ? 'scrollSimchasCentered 30s linear infinite' : 'none' }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {simchas.map(s => renderCard(s, '', true))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup1-', false))}
                {needsScroll && simchas.map(s => renderCard(s, 'dup2-', false))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Centered;
